export default {"src":"/_next/static/media/icon_warning_yellow.243825ad.svg","height":15,"width":17,"blurWidth":0,"blurHeight":0};